import React, { useState } from "react";
import LinkIcon from "@mui/icons-material/Link";
import CircularProgress from "@mui/material/CircularProgress";
import { initiateLexwareAuth } from "../../../../services/customer-services/customerIntegrationService";
import CommonButton from "../../../../component/button/Button";

const LexwareConnectButton = ({ text = "Connect Lexware Office" }) => {
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    setLoading(true);
    const res = await initiateLexwareAuth();
    if (res.isSuccess && res.url) {
      // Redirect the entire browser to Lexware's login page
      window.location.href = res.url;
    } else {
      alert("Could not initiate Lexware connection. Please try again.");
      setLoading(false);
    }
  };

  return (
    <CommonButton
      text={loading ? "Redirecting..." : text}
      icon={loading ? <CircularProgress size={20} color="inherit" /> : <LinkIcon />}
      onClick={handleConnect}
      disabled={loading}
      style={{ backgroundColor: "#00d2b2", color: "#fff" }}
    />
  );
};

export default LexwareConnectButton;